import forms from './forms'
import occurrences from './occurrences'
import navigation from './navigation'
import sprints from './sprints'
import calendar from './calendar'
import campaigns from './campaigns'
import information from './information'
import profile from './profile'
import reports from './reports'
import resources from './resources'
import surveys from './surveys'
import dashboard from './dashboard'
import tasks from './tasks'
import routines from './routines'
import exhibitions from './exhibitions'
import sync from './sync'
import diagnostics from './diagnostics'
import geolocation from './geolocation'
import licenses from './licenses'
import notifications from './notifications'
import users from './users'
import permissions from './permissions'
import auth from './auth'
import validations from './validations'
import common from './common'
import analytics from './analytics'
import controlTower from './controlTower'
import notices from './notices'

export default {
  yes: common.yes,
  no: common.no,
  na: common.na,
  forms,
  occurrences,
  navigation,
  calendar,
  campaigns,
  sprints,
  information,
  profile,
  reports,
  resources,
  surveys,
  dashboard,
  tasks,
  routines,
  exhibitions,
  sync,
  diagnostics,
  geolocation,
  licenses,
  notifications,
  users,
  permissions,
  auth,
  validations,
  common,
  analytics,
  controlTower,
  notices
}
